export const companyTranslation = {
  en: {
    // Navigation & Headers
    companies: "Companies",
    home: "Home",
    allCompanies: "All Companies",

    // Table Headers & Fields
    website: "Website",
    createdAt: "Created At",
    actions: "Actions",

    // Buttons & Actions
    edit: "Edit",
    delete: "Delete",
    remove: "Remove",
    cancel: "Cancel",
    confirm: "Confirm",

    // Company Form Labels
    addNewCompany: "Add New Company",
    updateCompany: "Update Company",
    addCompany: "Add Company",
    searchByTitle: "Search by title...",
    addCompanyButton: "+ Add Company",

    // Status Options
    active: "Active",
    inactive: "Inactive",

    // Address Form Labels
    addresses: "Addresses",
    addAnotherAddress: "+ Add Another Address",
    phone: "Phone",

    // User Selection
    user: "User",
    selectUser: "Select User",

    // Upload Related
    dragDropUpload: "Drag & Drop or Click to Upload",
    supportedFormats: "Supported formats: JPG, PNG",

    // Modal Messages
    areYouSureDelete: "Are you sure you want to delete",
    thisActionCannotBeUndone: "This action cannot be undone.",

    // Stats & Metrics
    totalCompanies: "Total Companies",
    verifiedCompanies: "Verified Companies",

    // Placeholders
    enterTitle: "Enter title",
    enterDescription: "Enter description",
    enterWebsite: "Enter website URL",
    enterName: "Enter name",
    enterEmail: "Enter email",
    enterPhone: "Enter phone number",
    enterAddress: "Enter address",

    // Validation Messages
    required: "This field is required",
    invalidEmail: "Invalid email address",
    invalidPhone: "Invalid phone number",
    invalidUrl: "Invalid website URL",

    "Choose date range for companies": "Choose date range for companies",

    editCompany: "Edit Company",
    commercialRegisterNumber: "Commercial Register Number",
    entityType: "Entity Type",
    entityTypeFormName: "Entity Type Form Name",

    title: "Title",
    name: "Name",
    nameLangId: "Name Language ID",
    nameLangDesc: "Name Language Description",
    registrationNumber: "Registration Number",
    vatNumber: "VAT Number",
    crNationalNumber: "CR National Number",
    crNumber: "CR Number",
    versionNo: "Version Number",
    crCapital: "CR Capital",
    companyDuration: "Company Duration",
    mainCrNationalNumber: "Main CR National Number",
    mainCrNumber: "Main CR Number",
    issueDateGregorian: "Issue Date (Gregorian)",
    issueDateHijri: "Issue Date (Hijri)",
    confirmationDateGregorian: "Confirmation Date (Gregorian)",
    confirmationDateHijri: "Confirmation Date (Hijri)",
    reactivationDateGregorian: "Reactivation Date (Gregorian)",
    reactivationDateHijri: "Reactivation Date (Hijri)",
    suspensionDateGregorian: "Suspension Date (Gregorian)",
    suspensionDateHijri: "Suspension Date (Hijri)",
    deletionDateGregorian: "Deletion Date (Gregorian)",
    deletionDateHijri: "Deletion Date (Hijri)",
    statusId: "Status ID",
    statusName: "Status Name",
    entityTypeId: "Entity Type ID",
    entityTypeName: "Entity Type Name",
    entityFormId: "Entity Form ID",
    entityFormName: "Entity Form Name",
    entityCharacters: "Entity Characters",
    licenseIssuerNationalNumber: "License Issuer National Number",
    licenseIssuerName: "License Issuer Name",
    headquarterCityId: "Headquarter City ID",
    headquarterCityName: "Headquarter City Name",
    industry: "Industry",
    companySize: "Company Size",
    country: "Country",
    city: "City",
    address: "Address",
    partnersNationalityId: "Partners Nationality ID",
    partnersNationalityName: "Partners Nationality Name",
    phoneNo: "Phone Number",
    mobileNo: "Mobile Number",
    email: "Email",
    websiteLink: "Website Link",
    estore: "E-Store",
    storeUrl: "Store URL",
    storeActivity: "Store Activity",
    currencyId: "Currency ID",
    currencyName: "Currency Name",
    capitalTypeId: "Capital Type ID",
    capitalTypeName: "Capital Type Name",
    cashCapital: "Cash Capital",
    inKindCapital: "In-Kind Capital",
    contributionValue: "Contribution Value",
    totalCashContribution: "Total Cash Contribution",
    totalInKindContribution: "Total In-Kind Contribution",
    stockCapital: "Stock Capital",
    stocks: "Stocks",
    fiscalCalendarTypeId: "Fiscal Calendar Type ID",
    fiscalCalendarTypeName: "Fiscal Calendar Type Name",
    fiscalYearEndMonth: "Fiscal Year End Month",
    fiscalYearEndDay: "Fiscal Year End Day",
    parties: "Parties",
    management: "Management",
    activities: "Activities",
    description: "Description",
    status: "Status",
    logo: "Logo",
    smtp: "SMTP",
    userId: "User ID",
    update: "Update",
    companyLogo: "Company Logo",
    uploadCompanyLogo: "Upload Company Logo",
    displayCompanyNameAndLogo: "Display your company name and logo when signing documents",
    enterJsonArray: "Enter JSON array",
    CompanyFlags: "Company Checks",
    isMain: "Is Main",
    inLiquidationProcess: "In Liquidation Process",
    hasEcommerce: "Has Ecommerce",
    isLicenseBased: "Is License Based",
    isFirstFiscalYear: "Is First Fiscal Year",
    wathqVerified: "Wathq Verified",
    selectIndustry: "Select Industry",
    selectCompanySize: "Select Company Size",
    selectCountry: "Select Country",
    selectStatus: "Select Status",
    companyUpdatedSuccessfully: "Company updated successfully",
    failedToUpdateCompany: "Failed to update company"
  },
  ar: {
    // Navigation & Headers
    companies: "الشركات",
    home: "الرئيسية",
    allCompanies: "جميع الشركات",

    // Table Headers & Fields
    website: "الموقع الإلكتروني",
    createdAt: "تاريخ الإنشاء",
    actions: "الإجراءات",

    // Buttons & Actions
    edit: "تعديل",
    delete: "حذف",
    remove: "إزالة",
    cancel: "إلغاء",
    confirm: "تأكيد",

    // Company Form Labels
    addNewCompany: "إضافة شركة جديدة",
    updateCompany: "تحديث الشركة",
    addCompany: "إضافة شركة",
    searchByTitle: "البحث حسب العنوان...",
    addCompanyButton: "+ إضافة شركة",

    // Status Options
    active: "نشط",
    inactive: "غير نشط",

    // Address Form Labels
    addresses: "العناوين",
    addAnotherAddress: "+ إضافة عنوان آخر",
    phone: "الهاتف",

    // User Selection
    user: "المستخدم",
    selectUser: "اختيار المستخدم",

    // Upload Related
    dragDropUpload: "اسحب وأفلت أو انقر للتحميل",
    supportedFormats: "الصيغ المدعومة: JPG، PNG",

    // Modal Messages
    areYouSureDelete: "هل أنت متأكد من حذف",
    thisActionCannotBeUndone: "لا يمكن التراجع عن هذا الإجراء",

    // Stats & Metrics
    totalCompanies: "إجمالي الشركات",
    verifiedCompanies: "الشركات الموثقة",

    // Placeholders
    enterTitle: "أدخل العنوان",
    enterDescription: "أدخل الوصف",
    enterWebsite: "أدخل رابط الموقع",
    enterName: "أدخل الاسم",
    enterEmail: "أدخل البريد الإلكتروني",
    enterPhone: "أدخل رقم الهاتف",
    enterAddress: "أدخل العنوان",

    // Validation Messages
    required: "هذا الحقل مطلوب",
    invalidEmail: "البريد الإلكتروني غير صحيح",
    invalidPhone: "رقم الهاتف غير صحيح",
    invalidUrl: "رابط الموقع غير صحيح",

    editCompany: "تعديل الشركة",
    commercialRegisterNumber: "رقم السجل التجاري",
    entityType: "نوع الكيان",
    entityTypeFormName: "اسم نموذج نوع الكيان",

    "Choose date range for companies": "اختر نطاق التاريخ للشركات",

    title: "العنوان",
    name: "الاسم",
    nameLangId: "معرّف لغة الاسم",
    nameLangDesc: "وصف لغة الاسم",
    registrationNumber: "رقم التسجيل",
    vatNumber: "رقم ضريبة القيمة المضافة",
    crNationalNumber: "الرقم الوطني للسجل التجاري",
    crNumber: "رقم السجل التجاري",
    versionNo: "رقم الإصدار",
    crCapital: "رأس مال السجل التجاري",
    companyDuration: "مدة الشركة",
    mainCrNationalNumber: "الرقم الوطني للسجل التجاري الرئيسي",
    mainCrNumber: "رقم السجل التجاري الرئيسي",
    issueDateGregorian: "تاريخ الإصدار (ميلادي)",
    issueDateHijri: "تاريخ الإصدار (هجري)",
    confirmationDateGregorian: "تاريخ التأكيد (ميلادي)",
    confirmationDateHijri: "تاريخ التأكيد (هجري)",
    reactivationDateGregorian: "تاريخ إعادة التفعيل (ميلادي)",
    reactivationDateHijri: "تاريخ إعادة التفعيل (هجري)",
    suspensionDateGregorian: "تاريخ التعليق (ميلادي)",
    suspensionDateHijri: "تاريخ التعليق (هجري)",
    deletionDateGregorian: "تاريخ الحذف (ميلادي)",
    deletionDateHijri: "تاريخ الحذف (هجري)",
    statusId: "معرّف الحالة",
    statusName: "اسم الحالة",
    entityTypeId: "معرّف نوع الكيان",
    entityTypeName: "اسم نوع الكيان",
    entityFormId: "معرّف شكل الكيان",
    entityFormName: "اسم شكل الكيان",
    entityCharacters: "خصائص الكيان",
    licenseIssuerNationalNumber: "الرقم الوطني لجهة إصدار الترخيص",
    licenseIssuerName: "اسم جهة إصدار الترخيص",
    headquarterCityId: "معرّف مدينة المقر الرئيسي",
    headquarterCityName: "اسم مدينة المقر الرئيسي",
    industry: "الصناعة",
    companySize: "حجم الشركة",
    country: "الدولة",
    city: "المدينة",
    address: "العنوان",
    partnersNationalityId: "معرّف جنسية الشركاء",
    partnersNationalityName: "اسم جنسية الشركاء",
    phoneNo: "رقم الهاتف",
    mobileNo: "رقم الجوال",
    email: "البريد الإلكتروني",
    websiteLink: "رابط الموقع الإلكتروني",
    estore: "المتجر الإلكتروني",
    storeUrl: "رابط المتجر",
    storeActivity: "نشاط المتجر",
    currencyId: "معرّف العملة",
    currencyName: "اسم العملة",
    capitalTypeId: "معرّف نوع رأس المال",
    capitalTypeName: "اسم نوع رأس المال",
    cashCapital: "رأس المال النقدي",
    inKindCapital: "رأس المال العيني",
    contributionValue: "قيمة المساهمة",
    totalCashContribution: "إجمالي المساهمة النقدية",
    totalInKindContribution: "إجمالي المساهمة العينية",
    stockCapital: "رأس مال الأسهم",
    stocks: "الأسهم",
    fiscalCalendarTypeId: "معرّف نوع التقويم المالي",
    fiscalCalendarTypeName: "اسم نوع التقويم المالي",
    fiscalYearEndMonth: "شهر نهاية السنة المالية",
    fiscalYearEndDay: "يوم نهاية السنة المالية",
    parties: "الأطراف",
    management: "الإدارة",
    activities: "الأنشطة",
    description: "الوصف",
    status: "الحالة",
    logo: "الشعار",
    smtp: "SMTP",
    userId: "معرّف المستخدم",
    update: "تحديث",
    companyLogo: "شعار الشركة",
    uploadCompanyLogo: "تحميل شعار الشركة",
    displayCompanyNameAndLogo: "عرض اسم وشعار شركتك عند توقيع المستندات",
    enterJsonArray: "أدخل مصفوفة JSON",
    CompanyFlags: "فحوصات الشركة",
    isMain: "رئيسي",
    inLiquidationProcess: "قيد التصفية",
    hasEcommerce: "يمتلك متجر إلكتروني",
    isLicenseBased: "يعتمد على الترخيص",
    isFirstFiscalYear: "السنة المالية الأولى",
    wathqVerified:  "معتمد من واثق",
    selectIndustry: "اختر الصناعة",
    selectCompanySize: "اختر حجم الشركة",
    selectCountry: "اختر الدولة",
    selectStatus: "اختر الحالة",
    companyUpdatedSuccessfully: "تم تحديث الشركة بنجاح",
    failedToUpdateCompany: "فشل في تحديث الشركة"
  },
};
